<script>
import { editorState } from "@app/store/editorStore.svelte.js";
import {
    insertHistoryAction
} from '@app/store/historyStore.svelte.js';
import {
    showModal
} from '@app/store/modalStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import { toast } from '@zerodevx/svelte-toast';
/* Animation */
import {
    slide
} from 'svelte/transition';
import {
    quintOut
} from 'svelte/easing';

import fixOverlap from '@cclib/functions/eventGroups/fixOverlap.js';
import sortByTime from '@cclib/functions/eventGroups/orderByTime.js';
import convertToPlainText from '@cclib/functions/quill/convertToPlainText.js';
import convertToPlainTextCustom from '@cclib/functions/quill/convertToPlainTextCustom.js';
import convertToHtml from '@cclib/functions/quill/convertToHtml.js';
import convertToPopOn from '@cclib/functions/special/convertToPopOn.js';
import fixRtlText from '@cclib/functions/utility/fixRtlText.js'; 
import reverseRtlStartEnd from '@cclib/functions/utility/reverseRtlStartEnd.js'; 
import quillClasses from '@cclib/dict/quillClasses.js';
import * as m from "@app/paraglide/messages.js";

/** @type {{currentState: boolean, toggleMenu: (menu: string) => void}} */
let { currentState, toggleMenu } = $props();

let textMenu = $state(false);

function handleToggleMenu() {    
    toggleMenu('format');
}

function closeMenu() {
    textMenu = false;
    toggleMenu(false);    
}

function spellNumbers() {
    try {
        let numbers = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
        eventGroupState[projectState.selected].events.forEach((event, index, events) => {
            events[index].text = event.text.replace(/\b\d\b/g, m => numbers[m])
        });

        eventGroupState[projectState.selected].selected = [];
        
        toast.push(m.spelling_numbers_complete(), {classes: ['toast-success']});

        insertHistoryAction({
            name: "spell numbers", //action name
            eventGroup: projectState.selected,
            snapshots: [{
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState)
            }]
        });
    } catch (err) {
        console.log(err);
        toast.push(m.spelling_numbers_failed({ error: err.message }), {classes: ['toast-danger']});
    } finally {
        closeMenu();
    }
}

function removeRepeatWords() {
    try {
        eventGroupState[projectState.selected].events.forEach((event, index, events) => {
            try {
                let plainText = convertToPlainText(event.text, " ");
                let matches = plainText.match(/(\b\S+\b)(?=\s\1)/gmi);
                if (matches){
                    plainText = plainText.replace(/(\b\S+\b)(?=\s\1)/gmi, "");
                    events[index].text = convertToHtml(plainText);
                }      
            } catch(e){
                console.log(e);
                console.log(index),
                console.log(e.message);
            }
        });

        eventGroupState[projectState.selected].selected = [];
        toast.push(m.removing_repeat_words_complete(), {classes: ['toast-success']});

        insertHistoryAction({
            name: "remove repeat words", //action name
            eventGroup: projectState.selected,
            snapshots: [{
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState)
            }]
        });
    } catch (err) {
        console.log(err);
        toast.push(m.removing_repeat_words_failed({ error: err.message }), {classes: ['toast-danger']});
    } finally {
        closeMenu();
    }
}

function replaceWithEllipses() {
    try {
        eventGroupState[projectState.selected].events.forEach((event, index, events) => {
            events[index].text =  event.text.replace(/\.\.+/gm, "…");
        });

        eventGroupState[projectState.selected].selected = [];
        


        toast.push(m.ellipses_replacement_complete(), {classes: ['toast-success']});

        insertHistoryAction({
            name: "ellipses replacement", //action name
            eventGroup: projectState.selected,
            snapshots: [{
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState)
            }]
        });
    } catch (err) {
        console.log(err);
        toast.push(m.ellipses_replacement_failed({ error: err.message }), {classes: ['toast-danger']});
    } finally {
        closeMenu();
    }
}

function fixEventOverlap(eventGroup) {
    eventGroupState[eventGroup] = fixOverlap(eventGroupState[eventGroup], editorState.minFrameGap, projectState.frameRate);
    
    insertHistoryAction({
        name: "fix overlap", //action name
        eventGroup: projectState.selected,
        snapshots: [{
            store: "eventGroupState",
            value: JSON.stringify(eventGroupState)
        }]
    });

    toast.push(m.fixed_event_overlap_success(), {classes: ['toast-success']});

    handleToggleMenu();
}

function orderByTime(eventGroup) {
    eventGroupState[eventGroup] = sortByTime(eventGroupState[eventGroup]);
    eventGroupState[projectState.selected].selected = [];
    insertHistoryAction({
        name: "ordering", //action name
        eventGroup: projectState.selected,
        snapshots: [{
            store: "eventGroupState",
            value: JSON.stringify(eventGroupState)
        }]
    });

    toast.push(m.events_ordered_by_time(), {classes: ['toast-success']});
}

function toggleTextMenu() {
    textMenu = !textMenu;
    handleToggleMenu();
}

function snapToEventEnds() {
    /* 0.5 seconds is the range we're looking for but it could be tighter... not sure yet. */
    try {
        sortByTime(eventGroupState[projectState.selected]).events.forEach((event, eventIndex, eventsArray) => {
            if (eventIndex > 0 && event.start <= eventsArray[eventIndex - 1].end + 0.5) {
                eventsArray[eventIndex].start = eventsArray[eventIndex - 1].end + (editorState.minFrameGap / projectState.frameRate);
            }
        });

        eventGroupState[projectState.selected] = eventGroupState[projectState.selected];

        insertHistoryAction({
            name: "snap to events", //action name
            eventGroup: projectState.selected,
            snapshots: [{
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState)
            }]
        });

        toast.push(m.snap_to_event_ends_success(), {classes: ['toast-success']});

    } catch (err) {
        console.log(err, err.message);
        toast.push(m.snap_to_event_ends_failed({ error: err.message }), {classes: ['toast-danger']});
    } finally {
        closeMenu();
    }

}

function snapToEventStarts() {
    /* 0.5 seconds is the range we're looking for but it could be tighter... not sure yet. */
    try {
        sortByTime(eventGroupState[projectState.selected]).events.forEach((event, eventIndex, eventsArray) => {
            if (eventsArray[eventIndex + 1] && event.end >= eventsArray[eventIndex + 1].start - 0.5) {
                eventsArray[eventIndex].end = eventsArray[eventIndex + 1].start - (editorState.minFrameGap / projectState.frameRate);
            }
        });

        eventGroupState[projectState.selected] = eventGroupState[projectState.selected];

        insertHistoryAction({
            name: "snap to events", //action name
            eventGroup: projectState.selected,
            snapshots: [{
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState)
            }]
        });

        toast.push(m.snap_to_event_start_success(), {classes: ['toast-success']});

    } catch (err) {
        console.log(err, err.message);
        toast.push(m.snap_to_event_start_failed({ error: err.message }), {classes: ['toast-danger']});
    } finally {
        closeMenu();
    }

}

function unwrapElement(element) {
    element.replaceWith(...element.childNodes);
}

function removeInlineFormatting(text) {
    if (!text) {
        return text;
    }

    const template = document.createElement("template");
    template.innerHTML = text;
    const colorFormattedSpans = [];

    template.content.querySelectorAll("em, u, strong").forEach(unwrapElement);
    template.content.querySelectorAll("[style]").forEach(element => {
        const hadColorFormatting = element.style.getPropertyValue("color") || element.style.getPropertyValue("background-color");

        element.style.removeProperty("color");
        element.style.removeProperty("background-color");

        if (!element.getAttribute("style")?.trim()) {
            element.removeAttribute("style");
        }

        if (hadColorFormatting && element.tagName.toLowerCase() === "span") {
            colorFormattedSpans.push(element);
        }
    });

    colorFormattedSpans.forEach(element => {
        if (element.parentNode && element.attributes.length === 0) {
            unwrapElement(element);
        }
    });

    return template.innerHTML;
}

function clearFormatting() {
    try {
        eventGroupState[projectState.selected].selected.forEach((eventIndex, count) => {
            eventGroupState[projectState.selected].events[eventIndex].text = removeInlineFormatting(eventGroupState[projectState.selected].events[eventIndex].text);
        });

        eventGroupState[projectState.selected].selected = [];

        insertHistoryAction({
            name: "clear formatting", //action name
            eventGroup: projectState.selected,
            snapshots: [{
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState)
            }]
        });

        toast.push(m.clear_formatting_success(), {classes: ['toast-success']});
    } catch (err) {
        console.log(err, err.message);
        toast.push(err.message, {classes: ['toast-danger']});
    } finally {
        closeMenu();
    }
}

function boldEvent() {
    try {
        eventGroupState[projectState.selected].selected.forEach((eventIndex, count) => {
            if (eventGroupState[projectState.selected].events[eventIndex].text.match(/<strong>/)) {
                eventGroupState[projectState.selected].events[eventIndex].text = eventGroupState[projectState.selected].events[eventIndex].text.replace(/<strong>|<\/strong>/gmi, "");
            } else {
                eventGroupState[projectState.selected].events[eventIndex].text = eventGroupState[projectState.selected].events[eventIndex].text.replace(/(?<=>)\s/g, "");
                eventGroupState[projectState.selected].events[eventIndex].text = eventGroupState[projectState.selected].events[eventIndex].text.replace(/(?<=>)(?!<|$)/gmi, "<strong>").replace(/(?=<\/p)/gmi, "</strong>");
            }
        });

        eventGroupState[projectState.selected].selected = [];

        insertHistoryAction({
            name: "bold event(s)", //action name
            eventGroup: projectState.selected,
            snapshots: [{
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState)
            }]
        });

        toast.push(m.bold_event_text(), {classes: ['toast-success']});
    } catch (err) {
        console.log(err, err.message);
        toast.push(err.message, {classes: ['toast-danger']});
    } finally {
        closeMenu();
    }
}

function underlineEvent() {
    try {
        eventGroupState[projectState.selected].selected.forEach((eventIndex, count) => {
            if (eventGroupState[projectState.selected].events[eventIndex].text.match(/<u>/)) {
                eventGroupState[projectState.selected].events[eventIndex].text = eventGroupState[projectState.selected].events[eventIndex].text.replace(/<u>|<\/u>/gmi, "");
            } else {
                eventGroupState[projectState.selected].events[eventIndex].text = eventGroupState[projectState.selected].events[eventIndex].text.replace(/(?<=>)\s/g, "");
                eventGroupState[projectState.selected].events[eventIndex].text = eventGroupState[projectState.selected].events[eventIndex].text.replace(/(?<=>)(?!<|$)/gmi, "<u>").replace(/(?=<\/p)/gmi, "</u>");
            }            
        });

        eventGroupState[projectState.selected].selected = [];

        insertHistoryAction({
            name: "underline event(s)", //action name
            eventGroup: projectState.selected,
            snapshots: [{
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState)
            }]
        });

        toast.push(m.underline_event_text(), {classes: ['toast-success']});
    } catch (err) {
        console.log(err, err.message);
        toast.push(err.message, {classes: ['toast-danger']});
    } finally {
        closeMenu();
    }
}

function italicizeEvent() {
    try {
        eventGroupState[projectState.selected].selected.forEach((eventIndex, count) => {
            if (eventGroupState[projectState.selected].events[eventIndex].text.match(/<em>/)) {
                eventGroupState[projectState.selected].events[eventIndex].text = eventGroupState[projectState.selected].events[eventIndex].text.replace(/<em>|<\/em>/gmi, "");
            } else {
                eventGroupState[projectState.selected].events[eventIndex].text = eventGroupState[projectState.selected].events[eventIndex].text.replace(/(?<=>)\s/g, "");
                eventGroupState[projectState.selected].events[eventIndex].text = eventGroupState[projectState.selected].events[eventIndex].text.replace(/(?<=>)(?!<|$)/gmi, "<em>").replace(/(?=<\/p)/gmi, "</em>");
            }            
        });

        eventGroupState[projectState.selected].selected = [];

        insertHistoryAction({
            name: "italicize event(s)", //action name
            eventGroup: projectState.selected,
            snapshots: [{
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState)
            }]
        });

        toast.push(m.italicize_event_text(), {classes: ['toast-success']});
    } catch (err) {
        console.log(err, err.message);
        toast.push(err.message, {classes: ['toast-danger']});
    } finally {
        closeMenu();
    }
}

function fixRtlEventText(){
    try {
        if (eventGroupState[projectState.selected].selected.length === 0){
            throw new Error(m.no_events_selected());
        }

        eventGroupState[projectState.selected].selected.forEach((eventIndex, count) => {
            let plainText = convertToPlainText(eventGroupState[projectState.selected].events[eventIndex].text);
            let correctedText = fixRtlText(plainText);
            eventGroupState[projectState.selected].events[eventIndex].text = convertToHtml(correctedText);            
        });

        eventGroupState[projectState.selected].selected = [];

        insertHistoryAction({
            name: "Fix RTL Text", //action name
            eventGroup: projectState.selected,
            snapshots: [{
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState)
            }]
        });

        toast.push(m.rtl_text_fixed(), {classes: ['toast-success']});
    } catch (err){
        console.log(err, err.message);
        toast.push(err.message, {classes: ['toast-danger']});
    } finally {
        closeMenu();
    }
}

function reverseRtlStartAndEnd(){
    try {
        if (eventGroupState[projectState.selected].selected.length === 0){
            throw new Error(m.no_events_selected());
        }

        eventGroupState[projectState.selected].selected.forEach((eventIndex, count) => {
            eventGroupState[projectState.selected].events[eventIndex] = reverseRtlStartEnd(eventGroupState[projectState.selected].events[eventIndex]);
        });

        eventGroupState[projectState.selected].selected = [];

        insertHistoryAction({
            name: "Fix RTL Text", //action name
            eventGroup: projectState.selected,
            snapshots: [{
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState)
            }]
        });

        toast.push(m.rtl_text_fixed(), {classes: ['toast-success']});
    } catch (err){
        console.log(err, err.message);
        toast.push(err.message, {classes: ['toast-danger']});
    } finally {
        closeMenu();
    }
} 

function convertEventsToPopOn(){
    try {
        if (!eventGroupState[projectState.selected]){
            throw new Error("No Event Group selected");
        }

        eventGroupState[projectState.selected] = convertToPopOn(eventGroupState[projectState.selected]);

        insertHistoryAction({
            name: "Convert to Pop-On", //action name
            eventGroup: projectState.selected,
            snapshots: [{
                store: "eventGroupState",
                value: JSON.stringify(eventGroupState)
            }]
        });
    } catch(err){
        console.log(err, err.message);
        toast.push(err.message, {classes: ['toast-danger']});
    } finally {
        closeMenu();
    }
}


function convertToUpperCase(){
    //convert the text property of all selected events to uppercase
    if (!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0){
        toast.push(m.no_events_selected_uppercase(), {classes: ['toast-warning']});
        return;
    }

    eventGroupState[projectState.selected].selected.forEach((eventIndex, count) => {
        eventGroupState[projectState.selected].events[eventIndex].text = eventGroupState[projectState.selected].events[eventIndex].text.toUpperCase();        
    });

    eventGroupState[projectState.selected].selected = [];

    insertHistoryAction({
        name: "convert to upper case", //action name
        eventGroup: projectState.selected,
        snapshots: [{
            store: "eventGroupState",
            value: JSON.stringify(eventGroupState)
        }]
    });

    closeMenu();
}

function convertToLowerCase(){
    if (!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0){
        toast.push(m.no_events_selected_lowercase(), {classes: ['toast-warning']});
        return;
    }

    eventGroupState[projectState.selected].selected.forEach((eventIndex, count) => {
        eventGroupState[projectState.selected].events[eventIndex].text = eventGroupState[projectState.selected].events[eventIndex].text.toLowerCase();        
    });

    eventGroupState[projectState.selected].selected = [];

    insertHistoryAction({
        name: "convert to lower case", //action name
        eventGroup: projectState.selected,
        snapshots: [{
            store: "eventGroupState",
            value: JSON.stringify(eventGroupState)
        }]
    });

    closeMenu();
}

function convertToTitleCase(){
    if (!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0){
        return;
    }

    eventGroupState[projectState.selected].selected.forEach((eventIndex, count) => {
        eventGroupState[projectState.selected].events[eventIndex].text = eventGroupState[projectState.selected].events[eventIndex].text.toLowerCase().replace(/\b\w/g, match => match.toUpperCase());        
    });

    eventGroupState[projectState.selected].selected = [];
    insertHistoryAction({
        name: "convert to title case", //action name
        eventGroup: projectState.selected,
        snapshots: [{
            store: "eventGroupState",
            value: JSON.stringify(eventGroupState)
        }]
    });

    closeMenu();
}

function convertToSentenceCase(){
    if (!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0){
        return;
    }

    eventGroupState[projectState.selected].selected.forEach((eventIndex, count) => {
        //convert the text property of all selected events to sentence case. For example `<p class="ql-align-center">play dungeons and dragons.</p>` should convert to `<p class="ql-align-center">Play dungeons and dragons.</p>`

        eventGroupState[projectState.selected].events[eventIndex].text = convertToHtml(convertToPlainTextCustom(eventGroupState[projectState.selected].events[eventIndex].text).toLowerCase().replace(/(^\w|([.!?])\s\w)/g, match => match.toUpperCase()));    
    });

    eventGroupState[projectState.selected].selected = [];
    insertHistoryAction({
        name: "convert to title case", //action name
        eventGroup: projectState.selected,
        snapshots: [{
            store: "eventGroupState",
            value: JSON.stringify(eventGroupState)
        }]
    });

    closeMenu();
}

function splitOnDash(){
    //Split the text property of all selected events on the short and long dash characters when the dash is preceded by a space or followed by a space. For example, `<p class="ql-align-center">-Det er Dracula! -Drep ham.</p>` should become <p class="ql-align-center">-Det er Dracula!</p><p class="ql-align-center">-Drep ham.</p>
    if (!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0){
        return;
    }
    
    eventGroupState[projectState.selected].selected.forEach((eventIndex, count) => {
        eventGroupState[projectState.selected].events[eventIndex].text = eventGroupState[projectState.selected].events[eventIndex].text.replace(/(\s-|-\s)/g, match => {
            return match === " -" ? `</p><p class='${quillClasses.align[eventGroupState[projectState.selected].events[eventIndex].alignment]}'>-` : `-</p><p class='${quillClasses.align[eventGroupState[projectState.selected].events[eventIndex].alignment]}'>`;
        });        
    });

    eventGroupState[projectState.selected].selected = [];

    insertHistoryAction({
        name: "split on dash", //action name
        eventGroup: projectState.selected,
        snapshots: [{
            store: "eventGroupState",
            value: JSON.stringify(eventGroupState)
        }]
    });

    closeMenu();
}
</script>

<li class="nav-item dropdown {currentState ? 'show' : ''}" role="menuitem">
    <a onclick={handleToggleMenu} 
       class="dropdown-toggle nav-link" 
       href="#!/" 
       id="formatMenuButton"
       role="button"
       aria-haspopup="true"
       aria-expanded={currentState ? 'true' : 'false'}
       aria-label={m.format_menu()}>{m.format()}</a>
    <div class="dropdown-menu {currentState ? 'show' : ''}" 
         role="menu" 
         aria-labelledby="formatMenuButton">
        <!-- Bold -->
        <a class="dropdown-item {eventGroupState[projectState.selected] && eventGroupState[projectState.selected].selected.length > 0 ? '' : 'disabled'}" 
           href="#!/" 
           onclick={boldEvent} 
           role="menuitem"
           id="boldButton"
           aria-label={m.bold_selected_events()}
           aria-disabled={!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0}>
           <i class="bi bi-type-bold" aria-hidden="true"></i> {m.bold()}
        </a>
        <!-- Underline-->
        <a class="dropdown-item {eventGroupState[projectState.selected] && eventGroupState[projectState.selected].selected.length > 0 ? '' : 'disabled'}" 
           href="#!/" 
           onclick={underlineEvent} 
           role="menuitem"
           id="underlineButton"
           aria-label={m.underline_selected_events()}
           aria-disabled={!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0}>
           <i class="bi bi-type-underline" aria-hidden="true"></i> {m.underline()}
        </a>
        <!-- Italics -->
        <a class="dropdown-item {eventGroupState[projectState.selected] && eventGroupState[projectState.selected].selected.length > 0 ? '' : 'disabled'}" 
           href="#!/" 
           onclick={italicizeEvent} 
           role="menuitem"
           id="italicsButton"
           aria-label={m.italicize_selected_events()}
           aria-disabled={!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0}>
           <i class="bi bi-type-italic" aria-hidden="true"></i> {m.italics()}
        </a>
        <!-- Clear Formatting -->
        <a class="dropdown-item {eventGroupState[projectState.selected] && eventGroupState[projectState.selected].selected.length > 0 ? '' : 'disabled'}" 
           href="#!/" 
           onclick={clearFormatting} 
           role="menuitem"
           id="clearFormattingButton"
           aria-label={m.clear_formatting_selected_events()}
           aria-disabled={!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0}>
           <i class="bi bi-fonts" style="margin-right:-5%" aria-hidden="true"></i><sub><i class="bi bi-x" aria-hidden="true"></i></sub> {m.clear_formatting()}
        </a>
        <hr class="dropdown-divider">
        <a class="dropdown-item" 
           href="#!/" 
           onclick={() => showModal("autoFormat")}
           role="menuitem"
           id="autoFormatButton"
           aria-label={m.auto_format_options()}>{m.auto_format_custom()}</a>
        
        <a class="dropdown-item" 
           href="#!/" 
           onclick={() => showModal('snapToShotChanges')} 
           role="menuitem"
           id="snapToShotsButton"
           aria-label={m.snap_to_shot_changes_desc()}>{m.snap_to_shot_changes()}</a>
        <a class="dropdown-item" 
           href="#!/" 
           onclick={snapToEventStarts} 
           role="menuitem"
           id="snapToEventStartsButton"
           aria-label={m.snap_to_event_start_desc()}>{m.snap_to_event_start()}</a>
        <a class="dropdown-item" 
           href="#!/" 
           onclick={snapToEventEnds} 
           role="menuitem"
           id="snapToEventEndsButton"
           aria-label={m.snap_to_event_end_desc()}>{m.snap_to_event_end()}</a>
        <hr class="dropdown-divider">
        <a class="dropdown-item" 
           href="#!/" 
           onclick={()=> fixEventOverlap(projectState.selected)}
           role="menuitem"
           id="fixEventOverlapButton"
           aria-label={m.fix_event_overlap()}>{m.fix_event_overlap()}</a>
        <a class="dropdown-item" 
           href="#!/" 
           onclick={()=> orderByTime(projectState.selected)}
           role="menuitem"
           id="orderByTimeButton"
           aria-label={m.order_events_by_time()}>{m.order_events_by_time()}</a>
        <a class="dropdown-item" 
           href="#!/" 
           onclick={()=> convertEventsToPopOn()}
           role="menuitem"
           id="convertToPopOnButton"
           aria-label={m.convert_to_pop_on()}>{m.convert_to_pop_on()}</a>
        <hr class="dropdown-divider">
        <a class="dropdown-item {eventGroupState[projectState.selected] && eventGroupState[projectState.selected].selected.length > 0 ? '' : 'disabled'}" 
           href="#!/" 
           onclick={() => showModal("captionStyle")}
           role="menuitem"
           id="captionStyleButton"
           aria-label={m.caption_style_desc()}
           aria-disabled={!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0}>{m.caption_style()}</a>
        <a class="dropdown-item {eventGroupState[projectState.selected] && eventGroupState[projectState.selected].selected.length > 0 ? '' : 'disabled'}" 
           href="#!/" 
           onclick={() => showModal("captionPosition")}
           role="menuitem"
           id="captionPositionButton"
           aria-label={m.caption_position_desc()}
           aria-disabled={!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0}>{m.caption_position()}</a>
        <!-- Text Submenu -->
        <hr class="dropdown-divider">
        <a onclick={toggleTextMenu} 
           class="dropdown-item dropdown-toggle" 
           href="#!/"
           role="button"
           id="textSubmenuButton"
           aria-haspopup="true"
           aria-expanded={textMenu ? 'true' : 'false'}
           aria-label={m.text_submenu()}>{m.text()}</a>
        {#if textMenu}
        <div transition:slide={{duration: 400, easing: quintOut }}
             role="menu"
             aria-labelledby="textSubmenuButton">
            <a onclick={() => spellNumbers()} 
               class="dropdown-item bg-secondary" 
               href="#!/"
               role="menuitem"
               id="spellNumbersButton"
               aria-label={m.spell_numbers_desc()}>{m.spell_numbers()}</a>
            <a onclick={() => removeRepeatWords()} 
               class="dropdown-item bg-secondary" 
               href="#!/"
               role="menuitem"
               id="removeRepeatWordsButton"
               aria-label={m.remove_repeat_words()}>{m.remove_repeat_words()}</a>
            <a onclick={() => replaceWithEllipses()} 
               class="dropdown-item bg-secondary" 
               href="#!/"
               role="menuitem"
               id="replaceWithEllipsesButton"
               aria-label={m.replace_ellipses_desc()}>{m.replace_ellipses()}</a>
            <a onclick={() => splitOnDash()} 
               class="dropdown-item bg-secondary" 
               href="#!/"
               role="menuitem"
               id="splitOnDashButton"
               aria-label={m.split_on_dash()}>{m.split_on_dash()}</a>
            <hr class="dropdown-divider m-0">
            <a onclick={() => fixRtlEventText()} 
               class="dropdown-item bg-secondary" 
               href="#!/"
               role="menuitem"
               id="fixRtlTextButton"
               aria-label={m.fix_rtl_text()}>{m.fix_rtl_text()}</a>
            <a onclick={() => reverseRtlStartAndEnd()} 
               class="dropdown-item bg-secondary" 
               href="#!/"
               role="menuitem"
               id="reverseRtlStartAndEndButton"
               aria-label={m.reverse_rtl_start_end()}>{m.reverse_rtl_start_end()}</a>
            <hr class="dropdown-divider m-0">
            <a onclick={() => convertToUpperCase()} 
               class="dropdown-item bg-secondary" 
               href="#!/"
               role="menuitem"
               id="convertToUpperCaseButton"
               aria-label={m.text_to_upper_case()}>{m.text_to_upper_case()}</a>
            <a onclick={() => convertToLowerCase()} 
               class="dropdown-item bg-secondary" 
               href="#!/"
               role="menuitem"
               id="convertToLowerCaseButton"
               aria-label={m.text_to_lower_case()}>{m.text_to_lower_case()}</a>
            <a onclick={() => convertToTitleCase()} 
               class="dropdown-item bg-secondary" 
               href="#!/"
               role="menuitem"
               id="convertToTitleCaseButton"
               aria-label={m.text_to_title_case()}>{m.text_to_title_case()}</a>
            <a onclick={() => convertToSentenceCase()} 
               class="dropdown-item bg-secondary" 
               href="#!/"
               role="menuitem"
               id="convertToSentenceCaseButton"
               aria-label={m.text_to_sentence_case()}>{m.text_to_sentence_case()}</a>
        </div>
        {/if}
    </div>
</li>

<style lang="css">
.bg-secondary:hover {
    background-color: #366597 !important;
}
</style>
